import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "textarea", "submitButton"]
  static values = { url: String, title: String }

  connect() {
    this.modal = this.element.querySelector('.comment-modal')
  }

  show(event) {
    event.preventDefault()
    
    // Get the URL, title, and namespace from the button's data attributes
    const button = event.currentTarget
    const url = button.getAttribute('data-comment-modal-url-value')
    const title = button.getAttribute('data-comment-modal-title-value')
    const namespace = button.getAttribute('data-comment-modal-namespace-value')
    
    // Update the modal's form action, title, and namespace
    this.updateModal(url, title, namespace)
    
    // Show the modal
    this.modal.classList.remove('hidden')
    
    // Focus on the textarea
    if (this.hasTextareaTarget) {
      this.textareaTarget.focus()
    }
  }

  showSpecific(event) {
    event.preventDefault()
    
    // Get the target modal ID from the button's data attributes
    const button = event.currentTarget
    const targetModalId = button.getAttribute('data-comment-modal-target-value')
    const targetModal = document.getElementById(targetModalId)
    
    if (targetModal) {
      targetModal.classList.remove('hidden')
      
      // Focus on the textarea in the target modal
      const textarea = targetModal.querySelector('[data-comment-modal-target="textarea"]')
      if (textarea) {
        textarea.focus()
      }
    }
  }

  hide(event) {
    if (event.target === event.currentTarget || event.target.classList.contains('close')) {
      event.preventDefault()
      event.stopPropagation()
      this.hideModal()
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.hideModal()
  }

  hideModal() {
    this.modal.classList.add('hidden')
    this.clearForm()
  }

  submit() {
    // Let Rails handle the form submission naturally with CSRF token
    // This method is called after turbo:submit-end
  }

  updateModal(url, title, namespace) {
    // Update form action directly
    if (this.hasFormTarget) {
      this.formTarget.action = url
      this.formTarget.method = 'post'
    }
    
    // Update modal title
    const titleElement = this.element.querySelector('h3')
    if (titleElement) {
      titleElement.textContent = title
    }
    
    // Update textarea name attribute with the correct namespace
    if (this.hasTextareaTarget) {
      this.textareaTarget.name = `${namespace}[comment]`
    }
  }

  clearForm() {
    if (this.hasTextareaTarget) {
      this.textareaTarget.value = ''
    }
  }
}